import i18n from "../translations";

export default class PeppolHelper {
}